import { api } from "apiConnections";

const requests = {
    login: (data, config) => api.post(`/login`, data, config),
    logout: (data, config) => api.post(`/logout`, data, config),
    me: (config) => api.get(`/user/me`, config),
};

export default requests;
